'use strict';

var $ = require('jquery');

// Constructor
var DynamicsModal = function() {
    $.expr[':'].Contains = function(a,i,m){
        return (a.textContent || a.innerText || "").toUpperCase().indexOf(m[3].toUpperCase())>=0;
    };

    listFilter($('h2.dynamics-modal__header'), $('.dynamics-modal__available-dynamics'));

    $('.dynamics-modal__nav a.close').on('click touchstart', function () {
        $('body').removeClass('show-dynamics');
        $('html').css('overflow', 'auto');
        $('.card-fault.selected').removeClass('selected');
    });

    $('.dynamics-modal__module-info-toggle').on('click touchstart', function () {
        var dynamicsModal = $('.dynamics-modal');
        var collapsedClass = 'dynamics-modal--nav-collapsed';
        dynamicsModal.toggleClass(collapsedClass);
    })
};

function listFilter(header, list) {
    var form = $('<form>').attr({'class': 'dynamics-modal__filterform', 'action': '#'}),
        input = $('<input>').attr({'class': 'dynamics-modal__filterinput', 'type': 'text'});

    $(form).append(input).appendTo(header);
    $(form).on('click touchstart', function (e) {
        e.stopPropagation();
        $(input).focus();
    });

    $(input).change(function () {
        var filter = $(this).val();
        if (filter) {
            $(this).addClass('open');
            $(list).find('a.dynamic-link:not(:Contains(' + filter + '))').parent().fadeOut(300);
            $(list).find('a.dynamic-link:Contains(' + filter + ')').parent().fadeIn(300);
        } else {
            $(this).removeClass('open');
            $(list).find('.dynamic').fadeIn(300);
        }
    }).keyup(function () {
        $(this).change();
    });
}

module.exports = DynamicsModal;
